export function openAdminPanel() {
  return window.navAdmin?.();
}
